"use client";

import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { BottomSheet, BottomSheetBody, Chip, classNames, FlexCenter, FlexColumn, Media, Popover, SkeletonLine, TextBody } from "@opensea/ui-kit";
import { Settings } from "@opensea/ui-kit/icons";
import { head } from "es-toolkit/array";
import { useEffect, useMemo, useState } from "react";
import { useFormContext, useFormState, useWatch } from "react-hook-form";
import { Button } from "../../../../../components/Button";
import { useSwapContext } from "../../provider/SwapContext";
import { CustomDestinationWalletToggle } from "./CustomDestinationWalletToggle";
import { MaxSlippageInput } from "./MaxSlippageInput";
export function SwapConfiguration(t0) {
  const $ = _c(40);
  const {
    className
  } = t0;
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    errors
  } = useFormState(t1);
  const {
    isAutoSlippageEnabled,
    isLoadingInitialToCurrency
  } = useSwapContext();
  let t2;
  if ($[2] !== control) {
    t2 = {
      control,
      name: "maxSlippage"
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const maxSlippage = useWatch(t2);
  const [isOpen, setIsOpen] = useState(false);
  const customDestinationWalletSupported = useCustomDestinationWalletSupported();
  const customDestinationWalletRequired = useCustomDestinationWalletRequired();
  const t3 = isOpen ? "border border-border-1" : "border border-transparent";
  const t4 = errors.maxSlippage && "border-error-1";
  let t5;
  if ($[4] !== className || $[5] !== t3 || $[6] !== t4) {
    t5 = classNames("h-8 p-1", t3, t4, className);
    $[4] = className;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = isOpen ? "secondary" : "ghost";
  let t7;
  if ($[8] !== isAutoSlippageEnabled) {
    t7 = isAutoSlippageEnabled ? <Chip variant="frosted">Auto</Chip> : null;
    $[8] = isAutoSlippageEnabled;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== maxSlippage) {
    t8 = <TextBody className="pl-0.5 font-mono" size="xs">{maxSlippage}%</TextBody>;
    $[10] = maxSlippage;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Settings size={18} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t8) {
    t10 = <FlexCenter className="m-1.5 gap-2">{t7}{t8}{t9}</FlexCenter>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t5 || $[18] !== t6) {
    t11 = <Button className={t5} variant={t6}>{t10}</Button>;
    $[16] = t10;
    $[17] = t5;
    $[18] = t6;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const trigger = t11;
  if (isLoadingInitialToCurrency) {
    let t12;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <SkeletonLine className="h-4.5 w-20" />;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    return t12;
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <MaxSlippageInput />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== customDestinationWalletRequired || $[23] !== customDestinationWalletSupported) {
    t13 = <FlexColumn className="gap-2">{t12}<CustomDestinationWalletToggle required={customDestinationWalletRequired} supported={customDestinationWalletSupported} /></FlexColumn>;
    $[22] = customDestinationWalletRequired;
    $[23] = customDestinationWalletSupported;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isOpen || $[26] !== t13 || $[27] !== trigger) {
    t14 = <Media greaterThanOrEqual="md"><Popover align="end" className="w-[275px] rounded-lg p-2" content={t13} onOpenChange={setIsOpen} open={isOpen} portal={true}>{trigger}</Popover></Media>;
    $[25] = isOpen;
    $[26] = t13;
    $[27] = trigger;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <MaxSlippageInput />;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== customDestinationWalletRequired || $[31] !== customDestinationWalletSupported) {
    t16 = <BottomSheetBody className="px-4 py-6"><FlexColumn className="gap-4">{t15}<CustomDestinationWalletToggle required={customDestinationWalletRequired} supported={customDestinationWalletSupported} /></FlexColumn></BottomSheetBody>;
    $[30] = customDestinationWalletRequired;
    $[31] = customDestinationWalletSupported;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== isOpen || $[34] !== t16 || $[35] !== trigger) {
    t17 = <Media lessThan="md"><BottomSheet content={t16} modal={true} nested={true} onOpenChange={setIsOpen} open={isOpen} withCloseIcon={false}>{trigger}</BottomSheet></Media>;
    $[33] = isOpen;
    $[34] = t16;
    $[35] = trigger;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t14 || $[38] !== t17) {
    t18 = <>{t14}{t17}</>;
    $[37] = t14;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
}
export function useCustomDestinationWalletSupported() {
  const $ = _c(5);
  const {
    quote
  } = useSwapContext();
  const swapRoute = quote ? head(quote.swapRoutes) : undefined;
  const {
    setValue,
    getValues
  } = useFormContext();
  let t0;
  bb0: {
    if (!swapRoute || swapRoute.__typename !== "SwapRoute") {
      t0 = true;
      break bb0;
    }
    t0 = swapRoute.swapProvider === "RELAY";
  }
  const supported = t0;
  let t1;
  let t2;
  if ($[0] !== getValues || $[1] !== setValue || $[2] !== supported) {
    t1 = () => {
      const {
        customDestinationWalletEnabled
      } = getValues();
      setValue("customDestinationWalletEnabled", supported && customDestinationWalletEnabled);
    };
    t2 = [supported, setValue, getValues];
    $[0] = getValues;
    $[1] = setValue;
    $[2] = supported;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return supported;
}
export function useCustomDestinationWalletRequired() {
  const $ = _c(8);
  const {
    control,
    setValue
  } = useFormContext();
  let t0;
  if ($[0] !== control) {
    t0 = {
      control,
      name: "fromCurrency"
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fromCurrency = useWatch(t0);
  let t1;
  if ($[2] !== control) {
    t1 = {
      control,
      name: "toCurrency"
    };
    $[2] = control;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const toCurrency = useWatch(t1);
  const {
    getChain
  } = useChains();
  const {
    isLoadingInitialFromCurrency,
    isLoadingInitialToCurrency
  } = useSwapContext();
  toCurrency?.chainIdentifier;
  let t2;
  bb0: {
    if (isLoadingInitialFromCurrency || isLoadingInitialToCurrency) {
      t2 = false;
      break bb0;
    }
    const fromChain = getChain(fromCurrency.chainIdentifier);
    const toChain = toCurrency?.chainIdentifier ? getChain(toCurrency.chainIdentifier) : undefined;
    t2 = !!fromChain && !!toChain && fromChain.arch !== toChain.arch;
  }
  const required = t2;
  let t3;
  let t4;
  if ($[4] !== required || $[5] !== setValue) {
    t3 = () => {
      if (required) {
        setValue("customDestinationWalletEnabled", true);
      }
    };
    t4 = [required, setValue];
    $[4] = required;
    $[5] = setValue;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  return required;
}